import { ActiveBreadcrumb, SwitchContainer, ToggleButton, BreadcrumbContainer, ControlBar, PreviousBreadcrumb, SubTitle, Title, TitleContainer, TypeToggle } from './LearningCenterHeader.styles';
import React from 'react';
import { Breadcrumbs } from "@material-ui/core";
import PropTypes from 'prop-types';
import { buildTopicHierarchy } from "../../../../templates/resourcesHelperFunctions";

const getAncestorTopics = (allTopics) => {
  const ancestorTopics = allTopics?.filter((topic) => topic.ancestors === null);
  return ancestorTopics;
}

const LearningCenterHeader = (props) => {
  const ancestorTopics = getAncestorTopics(props.allTopics?.nodes);

  return(
  <>
  <TitleContainer>
    <Title>Learning Center</Title>
    <SubTitle>{props.subtitle}</SubTitle>
  </TitleContainer>
  <ControlBar>
    <BreadcrumbContainer>
      <Breadcrumbs>
        {props.breadcrumbs.map((crumb, i) => (
          !crumb.active ?
            <PreviousBreadcrumb href={crumb.link} key={i}>{crumb.text}</PreviousBreadcrumb> :
            <ActiveBreadcrumb key={i}>{crumb.text}</ActiveBreadcrumb>
        ))}
      </Breadcrumbs>
    </BreadcrumbContainer>
    {/*<SwitchContainer>
      <TypeToggle
        showSecondSwitch={props.showSecondSwitch}
      >
        {
          ancestorTopics?.map((topic, i) => <ToggleButton
            key={i}
            active={props.activeAncestor === topic.name}
            onClick={() => props.changeTopic(topic.name)}
            borderRadius={i === 0 ? "50px 0 0 50px" : i === ancestorTopics.length - 1 ? "0 50px 50px 0" : "0px"}
          >
            {topic.name}
          </ToggleButton>)
        }
      </TypeToggle>
      {
        props.showSecondSwitch && <TypeToggle
          showSecondSwitch={props.showSecondSwitch}
        >
          {
            props.secondSwitchTopics?.map((topic, i) => <ToggleButton
              key={i}
              active={props.activeParentTopic === topic}
              onClick={() => props.changeTopic(topic)}
              borderRadius={i === 0 ? "50px 0 0 50px" : i === props.secondSwitchTopics.length - 1 ? "0 50px 50px 0" : "0px"}
            >
              {topic}
            </ToggleButton>)
          }
        </TypeToggle>
      }
    </SwitchContainer>*/}
  </ControlBar>
  </>
  )
};

LearningCenterHeader.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string,
    text: PropTypes.string.isRequired,
    active: PropTypes.string.isRequired
  })),
};

LearningCenterHeader.defaultProps = {
  steps: null,
};

export default LearningCenterHeader;

